import { ref } from '@vue/composition-api';
// import { PartialRobotChatConfig, RobotChatConfig, SetProjectType, GetProjectType } from '../types';
// import { cloneDeep, defaults } from 'lodash';


const showAsideStatus = ref(false);
const currentComponent = ref();
const message = ref();

export const useAsideComponent = () => {
  const setAsideStatus = (status: boolean) => {
    showAsideStatus.value = status;
    if (!status) {
      setAsideComponent(null);
    }
  };

  const setAsideComponent = (component: string | null) => currentComponent.value = component;

  const setRuleMessage = (rule: any) => message.value = rule;

  return {
    showAsideStatus,
    setAsideStatus,
    setAsideComponent,
    currentComponent,
    setRuleMessage,
    message
  };
};
